import { render, staticRenderFns } from "./SiteUnavailable.vue?vue&type=template&id=7c0a8e70&scoped=true"
import script from "./SiteUnavailable.vue?vue&type=script&lang=js"
export * from "./SiteUnavailable.vue?vue&type=script&lang=js"
import style0 from "./SiteUnavailable.vue?vue&type=style&index=0&id=7c0a8e70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0a8e70",
  null
  
)

export default component.exports